import { inject, REQUEST } from '@angular/core';
import { MaintenanceService } from '../services/maintenance.service';
import { DeviceService } from '../services/device-detector/device.service';
import { Observable, of } from 'rxjs';

export function initMaintenance() {
  return (): Observable<boolean> => {
    const maintenanceService = inject(MaintenanceService);
    const deviceService = inject(DeviceService);
    const request = inject(REQUEST);

    const isSsrBuildProcess = deviceService.isPlatformServer() && !request;
    if (isSsrBuildProcess) {
      return of(true);
    }

    return maintenanceService.fetchAndSetMaintenanceInfo();
  };
}
